import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CurrencyInput from '../CurrencyInput';
import { API_BASE_URL } from '../../../config/ApiConfig';

function SaldoContaModal({ show, onClose, onSubmit, form, handleChange, title = 'CADASTRO DE SALDO CONTA' }) {
  const isEditing = form._isEditing;
  const [programas, setProgramas] = useState([]);
  const [contas, setContas] = useState([]);
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');

  useEffect(() => {
    if (!show) return;
    // Buscar todos os programas
    axios.get(`${API_BASE_URL.PROGRAMA}/all`, {
      headers: { Authorization: token ? `Bearer ${token}` : undefined }
    })
      .then(r => {
        // Espera-se [{id, descricao}]
        const data = Array.isArray(r.data) ? r.data : [];
        setProgramas(data);
      })
      .catch(() => setProgramas([]));
  }, [show, token]);

  useEffect(() => {
    if (!show || !form.idPrograma) {
      setContas([]);
      return;
    }
    axios.get(`${API_BASE_URL.CONTA}/findByEscolaAndPrograma`, {
      params: { idEscola: cnpj, idPrograma: form.idPrograma },
      headers: { Authorization: token ? `Bearer ${token}` : undefined }
    })
      .then(r => {
        const data = Array.isArray(r.data) ? r.data : [];
        setContas(data);
        if (data.length === 1) {
          handleChange({ target: { name: 'idConta', value: data[0].numConta } });
        }
      })
      .catch(() => setContas([]));
  }, [show, form.idPrograma, cnpj, token, handleChange]);

  if (!show) return null;
  return (
    <div className="modal show d-block" tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className={`modal-header ${isEditing ? 'bg-primary' : 'bg-success'} text-white`} style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-bank2 me-2"></i>{isEditing ? 'EDITAR SALDO CONTA' : 'NOVO SALDO CONTA'}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <label className="form-label">Programa *</label>
                <select className="form-select" name="idPrograma" value={form.idPrograma} onChange={handleChange} required disabled={isEditing}>
                  <option value="">Selecione...</option>
                  {programas.map(p => (
                    <option key={p.id} value={p.id}>{p.descricao}</option>
                  ))}
                </select>
              </div>
              <div className="row mb-3">
                <div className="col-md-7">
                  <label className="form-label">Conta *</label>
                  <select className="form-select" name="idConta" value={form.idConta} onChange={handleChange} required disabled={!form.idPrograma || isEditing}>
                    <option value="">{form.idPrograma ? 'Selecione...' : 'Selecione o programa'}</option>
                    {contas.map(c => <option key={c.numConta} value={c.numConta}>{c.numConta}</option>)}
                  </select>
                </div>
                <div className="col-md-5">
                  <label className="form-label">Valor *</label>
                  <CurrencyInput className="form-control" name="saldoFinal" value={form.saldoFinal} onChange={handleChange} required />
                </div>
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-success">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SaldoContaModal;
